<template>
  <div>
    <div class="res-assignment-card">
      <div class="d-flex gap">
        <AssignmentLink/>
        <Importance :importance="responsibilityImportance" />
        <ExNewBadgeVue v-if="showNewBadge"/>
        <Icon name="org_icon_responsibility"/>
        <div class="responsibility-text">
          <span v-if="show_codes">{{ responsibilityCode }}</span>
          <span class="name">
            {{ responsibilityName }}
          </span>
        </div>
      </div>
      <ResponsibilityAssignmentPathRows
        variant="card"
        :roleCode="roleCode"
        :roleName="roleName"
        :roleImportance="roleImportance"
        :positionCode="positionCode"
        :positionName="positionName"
        :positionImportance="positionImportance"
        :positionCommitment="positionCommitment"
        :show_codes="show_codes"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Icon from "@components/icons/Icon.vue";
import AssignmentLink from "@components/AssignmentLink/AssignmentLink";
import Importance from '@components/importance/Importance.vue';
import ExNewBadgeVue from "@components/ExNewBadge/ExNewBadge.vue";
import ResponsibilityAssignmentPathRows from "@components/ResponsibilityAssignmentPathRows/ResponsibilityAssignmentPathRows.vue";

const props = defineProps({
  responsibilityCode: {
    type: String,
    default: "#9999",
  },
  responsibilityName: {
    type: String,
    default: "Responsibility Name",
  },
  roleCode: {
    type: String,
    default: "",
  },
  roleName: {
    type: String,
    default: "",
  },
  positionCode: {
    type: String,
    default: "",
  },
  positionName: {
    type: String,
    default: "",
  },
  responsibilityImportance: {
    type: Number,
    default: 0,
  },
  roleImportance: {
    type: Number,
    default: 0,
  },
  positionImportance: {
    type: Number,
    default: 0,
  },
  positionCommitment: {
    type: String,
    default: "Primary",
  },
  assignedOn: {
    type: Date,
    default: () => new Date("2025-09-01")
  },
  newDuration: {
    type: Number,
    default: 15,
  },
  show_codes: {
    type: Boolean,
    default: false,
  }
});

const showNewBadge = computed(() => {
  const today = new Date();
  const todayPlusDuration = new Date();
  todayPlusDuration.setDate(today.getDate() + props.newDuration);
  const assignedDate = new Date(props.assignedOn);
  return assignedDate < todayPlusDuration;
});
</script>

<style>
.res-assignment-card .importance-container {
  height: 22px !important;
}
.res-assignment-card .badge-box {
  height: 24px;
  margin-top: -1px;
  padding: 3px 6px !important;
}
.res-assignment-card .responsibility-text {
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #475467;
  margin-bottom: 4px;
}
.res-assignment-card .responsibility-text .name {
  font-weight: 500;
  color: #101828;
}
.res-assignment-card > .d-flex.gap {
  gap: 7px;
}
.res-assignment-card .responsibility-sec {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 8px;
}
.res-assignment-card .responsibility-sec .resp-code {
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #475467;
}
.res-assignment-card .responsibility-sec .resp-name {
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #101828;
}
</style>